'use es6';

import apiClient from 'hub-http/clients/apiClient';
import { createTracker } from 'usage-tracker';
import { getAppRootUrl } from '../utils/urls';
import { getTrackerConfig } from '../utils/usageTracker';
import { getAuth } from '../actions/AuthActions';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
export const appConfig = {
  apiClient,
  blockingActions: [getAuth],
  rootUrl: getAppRootUrl(),
  usageTracker: createTracker(getTrackerConfig('in-app')),
  I18nProvider: createStandardI18nProvider()
};